<app-button
  [icon]="!$inputIAEnabled() ? 'creation' : 'filter-variant'"
  [iconScale]="$iconScale()"
  [innerPadding]="'--padding-tiny'"
  [tooltip]="!$inputIAEnabled() ? t('ia_queries')() : t('static_filters')()"
  (click)="$inputIAEnabled.set(!$inputIAEnabled())"
/>
